import { Component, Input, OnInit } from '@angular/core';
import { dialogConfig } from '@modals/dialog.configure';
import { MbDialog, MbTooltipTrigger, MbIconText, MbIcon } from '@am/moebius';
import { ModalUniversalBenefitsDetailComponent } from '@modals/universal-benefits-detail/universal-benefits-detail.component';

@Component({
    selector: 'universal-benefits-detail',
    templateUrl: './universal-benefits-detail.component.html',
    styleUrls: ['./universal-benefits-detail.component.scss'],
    standalone: true,
    imports: [
        MbTooltipTrigger,
        MbIconText,
        MbIcon,
    ]
})
export class UniversalBenefitsDetailComponent implements OnInit {
  @Input()
  hotelId: string;

  public showModal: boolean;
  public hasUniversalExpress: boolean;

  constructor(private dialog: MbDialog) {}

  ngOnInit() {
    this.showModal = false;
    this.hasUniversalExpress =
      this.hotelId === '13798' || this.hotelId === '31866' || this.hotelId === '19319';
  }

  public toggleModal() {
    if (!this.dialog.isAnyDialogOpen) {
      const dialogData = { hasUniversalExpress: this.hasUniversalExpress };
      this.dialog.open(ModalUniversalBenefitsDetailComponent, {
        ...dialogConfig,
        dialogData: dialogData,
        closeBtn: true,
        size: 'lg',
      });
    }
  }
}
